import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { selectFundraiser } from '@client/redux/fundraiser/fundraiserSelectors';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import FundraiserCard from '@client/containers/fundraiserCard/FundraiserCard';
import UrlPagination from '@client/components/paginations/urlPagination/UrlPagination';
import { getSearchParams } from '@client/shared/utils/urlUtils/urlUtils';
import { loadHomePageData } from '@client/pages/homePage/duckHomePage';
import SearchFundraisers from '@client/components/searchFundraisers/SearchFundraisers';
import styles from '../homePage/homePage.scss';

class AllFundRaisersPage extends PureComponent {
  static loadData(dispatch, urlLocation) {
    const searchParams = getSearchParams(urlLocation);

    return dispatch(loadHomePageData(searchParams));
  }

  componentDidMount() {
    AllFundRaisersPage.loadData(this.props.dispatch, this.props.location);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const { dispatch, location } = this.props;

      if (prevProps.location.search !== location.search) {
        AllFundRaisersPage.loadData(dispatch, location);
      }
    }
  }

  render() {
    const { location, fundraiser, history } = this.props;
    const list = getIn(fundraiser, 'results');

    return (
      <div className={`${styles.homeRoute}`}>
        <div className={styleHelper.contentContainer}>
          <h2
            id={'listingSection'}
            className={`${styleHelper.titleMdPrimary} ${styles.fundraiserListingTitle} ${styleHelper.layoutMobileSidePadding}`}
          >
            Hitta insamlingar
          </h2>
          <SearchFundraisers
            onSearchFundraiser={this.onSearchFundraiser}
            onSelectCategory={this.onSelectCategory}
            location={location}
            history={history}
          />
          <div
            className={`${styleHelper.alignmentContainer} ${styles.fundraiserListingProp}`}
          >
            <div className={styleHelper.cardListGrid}>
              {list &&
                list.map((fundraiser) => {
                  return (
                    <FundraiserCard
                      key={getIn(fundraiser, 'id')}
                      fundraiser={fundraiser}
                      showStatsInsteadOfDescription={true}
                    />
                  );
                })}
            </div>
          </div>
          <UrlPagination
            className={`${styles.urlPaginationProp} ${styles.urlPaginationPropBottom}`}
            pageCount={getIn(fundraiser, 'pageCount')}
          />
        </div>
      </div>
    );
  }
}

AllFundRaisersPage.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  fundraiser: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    fundraiser: selectFundraiser(state),
  };
}

export default connect(mapStateToProps)(withCookies(AllFundRaisersPage));
